import { useTranslation } from "react-i18next";
import ButtonHapticWrapper from "component/Button/ButtonHapticWrapper";
import requestAuthentication from "integrations/authentication";
import getPublicAssetUrl from "utils/PublicAsset";

type Props = {
    onDismiss: () => void;
};

const GuestSignupPrompt = ({ onDismiss }: Props) => {
    const { t } = useTranslation();

    const handleSignup = () => {
        onDismiss();
        void requestAuthentication("register");
    };

    return (
        <div
            className="ge-weekly-impact relative w-full max-w-md mx-auto rounded-3xl border-[7px] border-white px-5 pb-6 pt-7 text-blue-950 shadow-[0_12px_32px_rgba(10,30,80,0.4)]"
            style={{
                background: "radial-gradient(circle at 50% 0%, #ffffff 0%, #dbeafe 45%, #bfdbfe 100%)",
            }}
        >
            <span className="absolute left-1/2 -top-[18px] z-10 -translate-x-1/2 whitespace-nowrap rounded-full border-2 border-white bg-blue-900 px-3.5 py-1 text-[9px] font-extrabold uppercase tracking-[0.16em] text-white shadow-[0_3px_8px_rgba(30,64,175,0.28)]">
                {t("signup_prompt.guest_badge")}
            </span>

            <div className="relative mx-auto mb-4 mt-1 h-24 w-[132px]" aria-hidden="true">
                <div
                    className="absolute left-1/2 top-1/2 h-24 w-32 -translate-x-1/2 -translate-y-1/2 rounded-full blur-xl"
                    style={{ background: "rgba(59,130,246,0.22)" }}
                />

                <img
                    src={getPublicAssetUrl("assets/icons/card.webp")}
                    alt=""
                    draggable={false}
                    className="absolute left-2.5 top-4 h-[52px] w-[52px] -rotate-[18deg] drop-shadow-[0_4px_6px_rgba(30,64,175,0.22)]"
                />
                <img
                    src={getPublicAssetUrl("assets/icons/card.webp")}
                    alt=""
                    draggable={false}
                    className="absolute right-2.5 top-4 h-[52px] w-[52px] rotate-[18deg] drop-shadow-[0_4px_6px_rgba(30,64,175,0.22)]"
                />

                <div className="absolute left-1/2 top-1 h-20 w-20 -translate-x-1/2">
                    <div className="h-full w-full overflow-hidden rounded-full border-4 border-white bg-blue-200 shadow-[0_8px_18px_rgba(30,64,175,0.3)]">
                        <img
                            src={getPublicAssetUrl("assets/avatars/0.webp")}
                            alt=""
                            draggable={false}
                            className="h-full w-full object-cover"
                        />
                    </div>

                    <div className="absolute -bottom-1 -right-1 flex h-8 w-8 items-center justify-center rounded-full border-[3px] border-white bg-green-500 text-white shadow-[0_4px_10px_rgba(22,163,74,0.35)]">
                        <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 12.5l4.25 4.25L19 7" />
                        </svg>
                    </div>
                </div>
            </div>

            <h2 className="text-center font-changa-one text-xl uppercase tracking-wide text-blue-950">
                {t("signup_prompt.title")}
            </h2>
            <p className="mx-auto mt-2 max-w-sm text-center text-sm leading-relaxed text-blue-950/60">
                {t("signup_prompt.description")}
            </p>

            <div className="mt-5 flex w-full gap-2.5">
                <ButtonHapticWrapper>
                    <button
                        type="button"
                        onClick={onDismiss}
                        className="h-11 flex-1 cursor-pointer rounded-full bg-white/60 font-changa-one text-xs uppercase tracking-wide text-blue-950/60 transition-colors hover:bg-white"
                    >
                        {t("signup_prompt.later")}
                    </button>
                </ButtonHapticWrapper>
                <ButtonHapticWrapper>
                    <button
                        type="button"
                        onClick={handleSignup}
                        className="game-btn h-11 flex-[1.6] cursor-pointer rounded-full font-changa-one text-sm uppercase tracking-wide text-[#195b00]"
                    >
                        <span className="relative z-10">{t("signup_prompt.cta_button")}</span>
                    </button>
                </ButtonHapticWrapper>
            </div>
        </div>
    );
};

export default GuestSignupPrompt;
